<template>
  <div class="editToolbar">
    <el-tooltip
      effect="dark"
      content="撤销"
      placement="bottom"
      :open-delay="1000"
    >
      <div
        :class="canUndo ? 'undo_button' : 'undo_button_disabled'"
        @click="undo_redo('undo')"
      >
        <div class="icon"></div>
      </div>
    </el-tooltip>
    <el-tooltip
      effect="dark"
      content="返回"
      placement="bottom"
      :open-delay="1000"
    >
      <div
        :class="canRedo ? 'redo_button' : 'redo_button_disabled'"
        @click="undo_redo('redo')"
      >
        <div class="icon"></div>
      </div>
    </el-tooltip>
    <div class="ai_discern_button" @click="pickUpSubtitle">
      <div class="icon"></div>
      <div>配音转字幕</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import undoRedo from "./subtitleUndoRedo.vue";
import { submitAudio, checkPickUpStatus } from "./subtitleApi";
export default {
  name: "editToolbar",
  mixins: [undoRedo],
  data () {
    return {
      audios: [
        // {
        //   index: 0, //场景页index
        //   filename: "2020-7-15/1c5197c0-c664-11ea-ac0b-1fe7a9c07edb.mp4", //音频名字
        //   taskId: "", //识别字幕任务id
        //   status: 0, //0:还未识别 1:识别中 2:识别成功 3:不需要识别 4:识别任务创建失败
        //   data: [] //字幕
        // }
      ],
      pickUpTimeout: null, //字幕识别定时器
    };
  },
  props: {},
  components: {},
  methods: {
    undo_redo (type) {
      if (type == "undo") {
        this.undo();
      } else {
        this.redo();
      }
    },

    //区分是视频识别字幕还是项目识别字幕
    pickUpSubtitle () {
      if (this.$route.subtitle) {
        this.pickUpVideoSubtitle();
      } else {
        this.pickUpDraftSubtitle();
      }
    },

    pickUpVideoSubtitleFirst () {
      this.audios.push({
        index: 0,
        filename: this.subtitleObj.url,
        taskId: "",
        status: 0,
        data: [],
      });
      this.submitAudios(this.audios);
    },

    //获取需要识别的视频对象提交到服务器进行转换
    pickUpVideoSubtitle () {
      this.audios.push({
        index: 0,
        filename: this.subtitleObj.url,
        taskId: "",
        status: 0,
        data: [],
      });
      this.$modal.show("SubtitleMessageDialog", {
        view: "UseConfirmationDialog",
        resultCallback: (value) => {
          if (value && value.type == "Ok") {
            //this.startPickUpSubtitle();
            this.submitAudios(this.audios);
          }
        },
      });
    },

    //获取需要识别的项目音频对象提交到服务器进行转换
    pickUpDraftSubtitle () {
      let res = this.getScenesAudio();
      if (res.haveAudio) {
        this.audios = res.audios;
        this.$modal.show("SubtitleMessageDialog", {
          view: "UseConfirmationDialog",
          resultCallback: (value) => {
            if (value && value.type == "Ok") {
              //this.startPickUpSubtitle();
              this.submitAudios(this.audios);
            }
          },
        });
      } else {
        this.$modal.show("SubtitleMessageDialog", {
          view: "NoDubDialog",
          resultCallback: (value) => {
            if (value && value.type == "Ok") {
              this.$bus.emit("topnav.saveWorks");
              this.$store.commit("subtitle/setOpenSubtitle", false);
              this.$bus.emit("FeaturesPop_vue", {
                name: "volume_adjust",
                posx: 0,
                posy: 0,
                type: 1,
              });
              this.$bus.emit("collectPersonal_vue", {
                data: "collectMusicType",
              });
            }
          },
        });
      }
    },

    //获取项目中的音频
    getScenesAudio () {
      let sceneAudios = [];
      let haveAudio = false;
      // if (this.TOOL.soundRecord && this.TOOL.soundRecord.url) {
      //   haveAudio = true;
      //   let audio = {
      //     index: -1,
      //     filename: this.TOOL.soundRecord.url.replace(
      //       "https://resources.laihua.com/",
      //       ""
      //     ),
      //     taskId: "",
      //     status: 0,
      //     data: [],
      //   };
      //   sceneAudios.push(audio);
      // } else {
      //   for (var i = 0; i < this.TOOL.sprites.length; i++) {
      //     let sound = this.TOOL.sprites[i].getSound();
      //     let audio = {
      //       index: i,
      //       filename: "",
      //       taskId: "",
      //       status: 3,
      //       data: [],
      //     };
      //     if (sound && sound.url) {
      //       haveAudio = true;
      //       audio.filename = sound.url.replace(
      //         "https://resources.laihua.com/",
      //         ""
      //       );
      //       audio.status = 0;
      //     }
      //     sceneAudios.push(audio);
      //   }
      // }

      this.dubbingArr.forEach((v, i) => {
        haveAudio = true;
        let audio = {
          index: i,
          filename: v.url,
          taskId: "",
          status: 0,
          data: [],
        };
        sceneAudios.push(audio);
      })

      return { audios: sceneAudios, haveAudio: haveAudio };
    },

    //提交需要识别的音频
    async submitAudios (audios) {
      this.$store.commit("subtitle/toggle_isPreventDefault", false); //取消快捷
      this.$modal.show("SubtitleMessageDialog", {
        view: "PickUpingDialog",
        resultCallback: () => {
          this.pickUpCancel();
        },
      });

      let taskCount = 0;
      for (let i = 0; i < audios.length; i++) {
        let subtitle = audios[i];
        if (subtitle.status == 0) {
          let taskId = null;
          let filename = this.$unhandleAssetsUrl(subtitle.filename)
          let submitRes = await submitAudio(filename);
          if (submitRes) {
            if (submitRes.code === 200) {
              taskId = submitRes.data;
            } else {
              this.$message({
                showClose: false,
                message: submitRes.msg,
                type: "error",
                center: true,
              });
            }
          }
          if (taskId) {
            subtitle.taskId = taskId;
            subtitle.status = 1;

            taskCount++;
          } else {
            subtitle.status = 4;
          }
        }
      }

      if (taskCount > 0) {
        this.pickUpTimeout = setTimeout(() => {
          this.checkPickUpTasks(audios);
        }, 5000);
      } else {
        this.$modal.hide("SubtitleMessageDialog");
        this.$modal.show("SubtitleMessageDialog", {
          view: "NoAudioDialog",
        });
        this.$store.commit("subtitle/toggle_isPreventDefault", true); //恢复快捷键
      }
    },

    //轮询检测字幕识别任务的状态
    async checkPickUpTasks (audios) {
      let completeCount = 0;
      for (let i = 0; i < audios.length; i++) {
        let subtitle = audios[i];
        if (subtitle.status == 1) {
          this.checkPickUpSubtitle(subtitle);
        } else {
          completeCount++;
          continue;
        }
      }
      if (audios.length <= completeCount) {
        console.log(audios);
        this.pickUpSuccess();
      } else {
        this.pickUpTimeout = setTimeout(() => {
          this.checkPickUpTasks(audios);
        }, 5000);
      }
    },
    //检测识别状态
    async checkPickUpSubtitle (subtitle) {
      let res = await checkPickUpStatus(subtitle.taskId);
      if (res) {
        subtitle.status = 2;
        subtitle.data = res;
        subtitle.taskId = null;
      }
    },

    //识别成功
    pickUpSuccess () {
      this.$message({
        showClose: false,
        message: "识别成功！",
        type: "success",
        center: true,
      });

      this.$modal.hide("SubtitleMessageDialog");
      this.$store.commit("subtitle/toggle_isPreventDefault", true); //恢复快捷键
      this.$bus.emit("pickUpSubtitle", this.audios);
    },

    //取消识别
    pickUpCancel () {
      clearTimeout(this.pickUpTimeout);
      this.$modal.hide("SubtitleMessageDialog");
      this.$store.commit("subtitle/toggle_isPreventDefault", true); //恢复快捷键
    },

  },
  watch: {
    'subtitleObj.url' () {
      if (this.$route.transform && this.$route.subtitle) {
        this.pickUpVideoSubtitleFirst();
      }
    }
  },
  created () {
  },
  computed: {
    ...mapGetters({
      TOOL: "TOOL",
      subtitleObj: "subtitle/subtitleObj",
      dubbingArr: 'addSoundtrack/getDubbingArr'
    }),
  },
  mounted () {

  },
};
</script>

<style scoped lang='scss'>
.editToolbar {
  position: absolute;
  top: -44px;
  left: 0px;
  width: 500px;
  height: 34px;
  margin: 0px;
  display: flex;
  align-items: center;
  transition-duration: 0.3s;

  .undo_button,
  .redo_button,
  .undo_button_disabled,
  .redo_button_disabled {
    width: 44px;
    height: 34px;
    background: #fafaff;
    border-radius: 4px;
    cursor: pointer;
    margin-right: 3px;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .undo_button {
    .icon {
      width: 17px;
      height: 14px;
      background: url('../../../static/svg/subtitle/undo.svg') no-repeat center;
    }

    &:hover {
      background-color: #9692a9;
      .icon {
        width: 17px;
        height: 14px;
        background: url('../../../static/svg/subtitle/undo-active.svg')
          no-repeat center;
      }
    }
  }

  .undo_button_disabled {
    .icon {
      width: 17px;
      height: 14px;
      background: url('../../../static/svg/subtitle/undo-gray.svg') no-repeat
        center;
    }
  }

  .redo_button {
    .icon {
      width: 17px;
      height: 14px;
      background: url('../../../static/svg/subtitle/redo.svg') no-repeat center;
    }

    &:hover {
      background-color: #9692a9;
      .icon {
        width: 17px;
        height: 14px;
        background: url('../../../static/svg/subtitle/redo-active.svg')
          no-repeat center;
      }
    }
  }

  .redo_button_disabled {
    .icon {
      width: 17px;
      height: 14px;
      background: url('../../../static/svg/subtitle/redo-gray.svg') no-repeat
        center;
    }
  }

  .ai_discern_button {
    position: relative;
    width: 112px;
    height: 34px;
    padding: 0 10px;
    background: #fafaff;
    border-radius: 4px;
    border: 1px solid transparent;
    color: #474261;
    cursor: pointer;

    line-height: 34px;
    margin-left: 13px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .icon {
      width: 16px;
      height: 13px;
      background: url('../../../static/svg/subtitle/ai-discern.svg') no-repeat
        center;
    }

    &:hover {
      border: 1px solid #5778fb;
      color: #5778fb;

      .icon {
        background: url('../../../static/svg/subtitle/ai-discern-active.svg')
          no-repeat center;
      }
    }

    &:before {
      position: absolute;
      top: -50%;
      left: 100%;
      transform: translate(-50%, 50%);
      content: '限免';
      width: 36px;
      height: 16px;
      background: linear-gradient(
        108deg,
        rgba(54, 51, 47, 1) 0%,
        rgba(18, 16, 10, 1) 100%
      );
      border-radius: 8px;

      color: #f8dbb2;
      font-size: 12px;
      font-weight: bold;
      line-height: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/videoEditToolbar.vue